import { createSlice } from '@reduxjs/toolkit';
import {
  createMaintenance,
  fetchAllMaintenances,
  fetchMaintenanceById,
  updateMaintenance,
  deleteMaintenance,
  fetchMaintenancesByEmployeeId,
  fetchAssetMaintenanceBySupervisorHierarchy,
} from './assetMaintenanceAction';
import { AssetMaintenanceState } from './assetMaintenanceTypes';

const initialState: AssetMaintenanceState = {
  maintenances: [],
  selectedMaintenance: undefined,
  maintenanceByEmployee: [],
  maintenanceBySupervisor: [],
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    fetchByEmployee: false,
    fetchBySupervisor: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const assetMaintenanceSlice = createSlice({
  name: 'assetMaintenance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createMaintenance.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createMaintenance.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.maintenances.push(action.payload.data);
      })
      .addCase(createMaintenance.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllMaintenances.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllMaintenances.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.maintenances = action.payload.data;
      })
      .addCase(fetchAllMaintenances.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchMaintenanceById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchMaintenanceById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedMaintenance = action.payload.data;
      })
      .addCase(fetchMaintenanceById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateMaintenance.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateMaintenance.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.maintenances.findIndex(m => m.Id === action.payload.id);
        if (index !== -1) state.maintenances[index] = { ...action.payload.data, Id: action.payload.id };
      })
      .addCase(updateMaintenance.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      //FetchMaintenacneByID
      .addCase(fetchMaintenancesByEmployeeId.pending, (state) => {
        state.loadingStates.fetchByEmployee = true;
        state.errors.fetchByEmployee = undefined;
      })
      .addCase(fetchMaintenancesByEmployeeId.fulfilled, (state, action) => {
        state.loadingStates.fetchByEmployee = false;
        state.maintenanceByEmployee = action.payload.data;
      })
      .addCase(fetchMaintenancesByEmployeeId.rejected, (state, action) => {
        state.loadingStates.fetchByEmployee = false;
        state.errors.fetchByEmployee = action.payload as string;
      })

      //Fetch By Supervisor Hierarchy
      .addCase(fetchAssetMaintenanceBySupervisorHierarchy.pending, (state) => {
        state.loadingStates.fetchBySupervisor = true;
        state.errors.fetchBySupervisor = undefined;
      })
      .addCase(fetchAssetMaintenanceBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loadingStates.fetchBySupervisor = false;
        state.maintenanceBySupervisor = action.payload.data;
      })
      .addCase(fetchAssetMaintenanceBySupervisorHierarchy.rejected, (state, action) => {
        state.loadingStates.fetchBySupervisor = false;
        state.errors.fetchBySupervisor = action.payload as string;
      })

      // Delete
      .addCase(deleteMaintenance.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteMaintenance.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.maintenances = state.maintenances.filter(m => m.Id !== action.payload);
      })
      .addCase(deleteMaintenance.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default assetMaintenanceSlice.reducer;
